/* @flow */
import { Map } from 'immutable';

export function requestRowAdapter(json: Object) {
  return Map(json);
}
